import React from "react";
import "react-toastify/dist/ReactToastify.css";
type Props = {
  children: React.ReactNode;
};
const ToastProvider: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default ToastProvider;
